<script>
import GenericResourcesView from "@/components/GenericResourcesView";
import bus from "@/bus";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const resourcesStore = useResourcesStore();
    return { resourcesStore };
  },
  components: {
    GenericResourcesView,
  },
  data() {
    return {
      validateButtons: [
        {
          id: "approve",
          label: "views.admin.user_validation.buttons.accept",
          color: "airbnbBlue",
        },
        {
          id: "reject",
          label: "views.admin.user_validation.buttons.reject",
          color: "airbnbRed",
        },
        {
          id: "promote",
          label: "views.admin.user_validation.buttons.admin",
          color: "airbnbOrange",
        },
      ],
      updatedButtons: [
        {
          id: "acceptUpdate",
          label: "views.admin.user_validation.buttons.accept",
          color: "airbnbBlue",
        },
        {
          id: "rejectUpdate",
          label: "views.admin.user_validation.buttons.reject",
          color: "airbnbRed",
        },
      ],
      buttonLoading: false,
      errors: [],
    };
  },
  created() {
    bus.on("approve", this.approve);
    bus.on("reject", this.reject);
    bus.on("promote", this.promote);
    bus.on("acceptUpdate", this.acceptUpdate);
    bus.on("rejectUpdate", this.rejectUpdate);
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
    async approve({ id }) {
      this.buttonLoading = true;
      const error = await this.resourcesStore.approveAccount({ id });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      }
      this.buttonLoading = false;
    },
    async acceptUpdate({ id }) {
      this.buttonLoading = true;
      const error = await this.resourcesStore.acceptUpdate({ id });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      }
      this.buttonLoading = false;
    },
    async reject({ id }) {
      this.buttonLoading = true;
      await this.resourcesStore.deleteAccount({ id, type: "waiting" });
      this.buttonLoading = false;
    },
    async rejectUpdate({ id }) {
      this.buttonLoading = true;
      await this.resourcesStore.rejectUpdate({ id });
      this.buttonLoading = false;
    },
    async promote({ id }) {
      this.buttonLoading = true;
      const error = await this.resourcesStore.promoteAccount({ id });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      }
      this.buttonLoading = false;
    },
  },
};
</script>

<template>
  <div>
    <header class="p-4 font-semibold bg-white text-gray-600 border-t-2 border-solid border-gray-300">
      {{ $t("views.admin.user_validation.waiting") }}
    </header>
    <GenericResourcesView data-cy="waitingResView" class="p-5" type="waiting" :buttons="validateButtons" />

    <header class="mt-4 p-4 font-semibold bg-white text-gray-600 border-t-2 border-solid border-gray-300">
      {{ $t("views.admin.user_validation.modified") }}
    </header>
    <GenericResourcesView data-cy="updatedResView" class="p-5" type="updated" :buttons="updatedButtons"
      :buttonLoading="buttonLoading" />
  </div>
</template>
